import { Type } from 'typebox';
import { InstantMessage } from './instant-message.js';
export const MessagingMetadata = Type.Object({
    subjectKey: Type.String({ minLength: 1 }),
    bookmarkTimestamp: Type.Optional(Type.Number()),
    lastMessage: Type.Optional(InstantMessage),
    lastUnreadMessage: Type.Optional(InstantMessage)
});
